import { FETCH_REPORT_AGGREGATE_REQUEST, FETCH_REPORT_AGGREGATE_SUCCESS, FETCH_REPORT_AGGREGATE_FAILURE } from './actions';

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const reportAggregateReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REPORT_AGGREGATE_REQUEST:
            return { ...state, loading: true };
        case FETCH_REPORT_AGGREGATE_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_REPORT_AGGREGATE_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default reportAggregateReducer;
